<template>  
    <div>
        <v-tooltip bottom dark>
            <template #activator='data'>
                <v-btn text icon to="/formulieren/edit">
                    <v-icon medium="" color="success" v-on="data.on">mdi-auto-fix</v-icon>
                </v-btn>
            </template>
            <span>templates</span>
        </v-tooltip>     

       </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["app"])
  }
};
</script>
